import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_LEADS,
  GET_LEAD_DETAILS,
  CREATE_LEAD,
  UPDATE_LEAD,
  UPDATE_LEAD_ASSIGNEE,
  DELETE_LEAD,
  CHECK_CLIENT_NUMBER,
  RESET_CLIENT_NUMBER,
} from "./actionTypes"
import {
  getLeadsFail,
  getLeadsSuccess,
  getLeadDetailsSuccess,
  getLeadDetailsFail,
  createLeadFail,
  createLeadSuccess,
  updateLeadSuccess,
  updateLeadFail,
  deleteLeadSuccess,
  deleteLeadFail,
  checkClientNumberSuccess,
  checkClientNumberFail,
  updateLeadAssigneeSuccess,
  updateLeadAssigneeFail,
  // getLeadStatusCountSuccess,
  // getLeadStatusCountFail,
} from "./actions"

import { get, post, ApiPut, del } from "helpers/api_helper"
import { Notification } from "../../components/Common/Notification"

// Helper to check if branch is a valid value
const isValidBranch = (branch) => branch && branch !== "undefined" && branch !== "null" && branch !== ""

// Lead - This line cannot be edited or removed
function getLeadsAPi({
  page,
  sort,
  limit,
  searchText,
  vehicleId,
  typeValue,
  clientId,
  medium,
  sortByDate,
  StaffId,
  branchId,
  leadCondition,
  order,
  orderType,
}) {
  const branchQuery = isValidBranch(branchId) ? `&branch=${branchId}` : ""

  return get(
    `/lead/admin/all/?sort=${sort ? sort : ""}&leadType=${typeValue ? typeValue : ""
    }&vehicle=${vehicleId ? vehicleId : ""}&page=${page}&limit=${limit ? limit : 10
    }&search=${searchText ? searchText : ""}&client=${clientId ? clientId : ""
    }&medium=${medium ? medium : ""}&from=${sortByDate.from ? sortByDate?.from : ""
    }&to=${sortByDate.to ? sortByDate.to : ""}&assignee=${StaffId ? StaffId : ""
    }${branchQuery}&leadCondition=${leadCondition ? leadCondition : ""}&order=${order ? order : ""}&orderType=${orderType ? orderType : ""}`
  )
}

const getLeadDetailsAPi = leadId => {
  return get(`/lead/admin/${leadId}`)
}

const createLeadApi = ({ lead }) => {
  return post("/lead/admin/new", lead)
}

const updateLeadApi = ({ lead, leadId, isStatus }) => {
  if (isStatus) {
    return ApiPut(`/lead/admin/status/${leadId}`, lead)
  }
  return ApiPut(`/lead/admin/${leadId}`, lead)
}

const updateLeadAssigneeApi = ({ assignee, leadId }) => {
  return ApiPut(`/lead/admin/assignee/${leadId}`, { assignee })
}

const deleteLeadApi = leadId => {
  return del(`/lead/admin/${leadId}`)
}

function* fetchLeads({ payload }) {
  try {
    const response = yield call(getLeadsAPi, payload)
    yield put(getLeadsSuccess(response))
  } catch (error) {
    yield put(getLeadsFail(error))
  }
}

function* fetchLeadDetails({ payload: leadId }) {
  try {
    const response = yield call(getLeadDetailsAPi, leadId)
    yield put(getLeadDetailsSuccess(response))
  } catch (error) {
    yield put(getLeadDetailsFail(error))
  }
}
const checkClientNumberApi = ({ clientNumber }) => {
  return post(`/client/admin/phone/availability`, clientNumber)
}

function* onCreateLead({ payload }) {
  try {
    const response = yield call(createLeadApi, payload)
    yield put(createLeadSuccess(response))
    payload?.history?.push(`/lead-details/${response?._id}`)
    doneNotification("Lead Created Successfully!")
  } catch (error) {
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(createLeadFail(error))
  }
}

function* onUpdateLead({ payload }) {
  try {
    const response = yield call(updateLeadApi, payload)
    if (response) {
      Notification({
        type: "success",
        message: "Lead Updated Successfully!",
        title: "",
      })
      yield put(updateLeadSuccess(response))

      if (payload.history) {
        payload.history.goBack()
      }
      if (payload.onClose) {
        payload.onClose()
      }
    }
  } catch (error) {
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(updateLeadFail(error?.response?.data))
  }
}

function* onUpdateLeadAssignee({ payload }) {
  try {
    const response = yield call(updateLeadAssigneeApi, payload)
    if (response) {
      Notification({
        type: "success",
        message: "Lead Assignee Updated Successfully!",
        title: "",
      })
      yield put(updateLeadAssigneeSuccess(response))

      if (payload.onClose) {
        payload.onClose()
      }
    }
  } catch (error) {
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error.response?.data?.message,
        title: "",
      })
    }
    yield put(updateLeadAssigneeFail(error?.response?.data))
  }
}

function* onDeleteLead({ payload }) {
  try {
    const response = yield call(deleteLeadApi, payload?.leadId)
    yield put(deleteLeadSuccess(response))
    Notification({
      type: "success",
      message: "Lead Deleted Successfully!",
      title: "",
    })
    // Use redirectPath if provided, otherwise default to /lead/sales
    const redirectTo = payload?.redirectPath || "/lead/sales"
    payload.history.push(redirectTo)
  } catch (error) {
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    yield put(deleteLeadFail(error?.response?.data))
  }
}

// function* fetchLeadStatusCount({ payload: leadId }) {
//   try {
//     const response = yield call(getLeadStatusCountAPi, leadId)
//     yield put(getLeadStatusCountSuccess(response))
//   } catch (error) {
//     yield put(getLeadStatusCountFail(error))
//   }
// }
function* onCheckClientNumber({ payload }) {
  console.log(payload)
  try {
    const response = yield call(checkClientNumberApi, payload)
    yield put(checkClientNumberSuccess(response))
  } catch (error) {
    yield put(checkClientNumberFail(error))
  }
}
function* resetClientNumberSaga() {
  // Optionally log or trigger something else
  console.log("Categories details cleared.")
}

function* leadSaga() {
  yield takeEvery(GET_LEADS, fetchLeads)
  yield takeEvery(GET_LEAD_DETAILS, fetchLeadDetails)
  yield takeEvery(CREATE_LEAD, onCreateLead)
  yield takeEvery(UPDATE_LEAD, onUpdateLead)
  yield takeEvery(UPDATE_LEAD_ASSIGNEE, onUpdateLeadAssignee)
  yield takeEvery(DELETE_LEAD, onDeleteLead)
  yield takeEvery(CHECK_CLIENT_NUMBER, onCheckClientNumber)
  yield takeEvery(RESET_CLIENT_NUMBER, resetClientNumberSaga)

  // yield takeEvery(GET_LEAD_STATUS_COUNT, fetchLeadStatusCount)
}

export default leadSaga

function doneNotification(message) {
  Notification({
    type: "success",
    message: message,
    title: "",
  })
}
